module.exports = __webpack_public_path__ + "static/media/SkyScapeCrop.ac861661.png";